/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-17 14:30:54
 */
//import * as types from './mutation-types'
//异步操作state
export default {
	//设置appName
	setAppName({commit}, payload) {
		commit('SET_APP_NAME', payload)
	},
	//设置companyName
	setCompanyName({commit}, payload) {
		commit('SET_COMPANY_NAME', payload)
	},
	//设置organizationName
	setOrganizationName({commit}, payload) {
		commit('SET_ORGANIZATION_NAME', payload)
	},
	//organizationNickName
	setOrganizationNickName({commit}, payload) {
		commit('SET_ORGANIZATION_NICK_NAME', payload)
	},
	//organizationLogo
	setOrganizationLogo({commit}, payload) {
		commit('SET_ORGANIZATION_LOGO', payload)
	},
	//设置电话号码
	setTelePhone({commit}, payload) {
		commit('SET_TELEPHONE', payload)
	},
	//tabsView推入tab
	pushTab({commit}, payload) {
		commit('PUSH_TAB', payload)
	},
	//tabsView删除tab
	deleteTab({commit}, payload) {
		commit('DELETE_TAB', payload)
	},
	//重置tabsView
	resetTab({commit}) {
		commit('RESET_TAB')
	},
	//修改主题颜色
	changeThemeColor({commit}, payload) {
		commit('CHANGE_THEME_COLOR', payload)
	},
	//收起或展开菜单
	toggleLeftMenu({commit}) {
		commit('TOGGLE_LEFT_MENU')
	},
	//设置内容区表格的高度
	setContentTableHei({commit}, contentView) {
		commit('SET_CONTENT_TABLE_HEI', contentView)
	},
	//设置分页组件每页显示条目个数
	setPageSize({commit}, payload) {
		commit('SET_PAGE_SIZE', payload)
	},
	// 设置分页组件每页显示条目个数的最小基数
	setPageBaseSize({commit}, payload) {
		commit('SET_PAGE_BASE_SIZE', payload)
	},
	//设置角色权限 
	setRolePermission({commit}, payload){
		commit('SET_ROLE_PERMISSION', payload)
	},
	// 设置角色ID
	setRoleID({commit}, payload){
		commit('SET_ROLE_ID', payload)
	},
	// 设置能访问的bid
	setTableIdArr({commit}, payload){
		commit('SET_TABLE_ID_ARR', payload)
	},
	
	
}


// WEBPACK FOOTER //
// ./src/store/actions.js